const getDomainFrom = serverName => {
    return serverName.indexOf("buildbee") >= 0
        ? "buildbee.com"
        : "buildflow.online"
}

const legacy = window.location.origin.includes("buildflow")

const domain = () => (legacy ? "buildflow.online" : "buildbee.com")

const appDomain = () => (legacy ? "app.buildflow.online" : "app.buildbee.com")

const appName = () => (legacy ? "BuildFlow" : "BuildBee")

export default domain
export { getDomainFrom, appDomain, appName }



// WEBPACK FOOTER //
// ./src/domain.js